import servise from '@/router/axios'

// 分页查询 RTA 服务列表
export const getRtaPage = (params) => {
  return servise({
    url: '/ocpx/rta/page',
    method: 'get',
    params
  })
}

// 根据 ID 查询 RTA 服务详情
export const getRtaById = (id) => {
  return servise({
    url: `/ocpx/rta/${id}`,
    method: 'get'
  })
}

// 根据广告主 ID 查询 RTA 服务列表
export const getRtaListByAdvertiserId = (advertiserId) => {
  return servise({
    url: `/ocpx/rta/advertiser/${advertiserId}`,
    method: 'get'
  })
}

// 根据 Bean 名称查询 RTA 服务
export const getRtaByBeanName = (beanName) => {
  return servise({
    url: `/ocpx/rta/bean/${beanName}`,
    method: 'get'
  })
}

// 新增 RTA 服务
export const addRta = (data) => {
  return servise({
    url: '/ocpx/rta',
    method: 'post',
    data
  })
}

// 更新 RTA 服务
export const updateRta = (data) => {
  return servise({
    url: '/ocpx/rta',
    method: 'put',
    data
  })
}

// 删除 RTA 服务
export const deleteRta = (id) => {
  return servise({
    url: `/ocpx/rta/${id}`,
    method: 'delete'
  })
}

// 更新 RTA 服务状态
export const updateRtaStatus = (id, status) => {
  return servise({
    url: `/ocpx/rta/${id}/status/${status}`,
    method: 'put'
  })
}

// 查询所有启用的 RTA 服务
export const getEnabledRtaList = () => {
  return servise({
    url: '/ocpx/rta/enabled/list',
    method: 'get'
  })
}
